import React, { useState } from 'react';
import { createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from 'firebase/auth';
import { firebaseAuth } from '../firebase';
import { theme } from '../theme';
import { AuthShell, AuthInput, AuthButton } from './LoginPage';

export default function RegisterPage({ onLogin }) {
  const [name, setName]           = useState('');
  const [email, setEmail]         = useState('');
  const [password, setPassword]   = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError]         = useState('');
  const [busy, setBusy]           = useState(false);

  async function handleRegister(e) {
    e.preventDefault();
    setError('');

    if (password !== password2) { setError('Passwords do not match.'); return; }
    if (password.length < 6)    { setError('Password must be at least 6 characters.'); return; }

    setBusy(true);
    try {
      const cred = await createUserWithEmailAndPassword(firebaseAuth, email.trim(), password);
      if (name.trim()) {
        await updateProfile(cred.user, { displayName: name.trim() });
      }
      await sendEmailVerification(cred.user);
      // AuthContext picks up the signed-in user; App.js will route to VerifyEmailPage
    } catch (err) {
      setError(friendlyError(err.code));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthShell title="Create your account">
      <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <AuthInput label="Full name (optional)" type="text" value={name}
          onChange={e => setName(e.target.value)} autoFocus required={false} />
        <AuthInput label="Username (email)" type="email" value={email}
          onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
        <AuthInput label="Password" type="password" value={password}
          onChange={e => setPassword(e.target.value)} />
        <AuthInput label="Confirm password" type="password" value={password2}
          onChange={e => setPassword2(e.target.value)} />

        {error && <p style={{ color: theme.danger, fontSize: 13 }}>{error}</p>}

        <AuthButton disabled={busy}>{busy ? 'Creating account…' : 'Create account'}</AuthButton>
      </form>

      <p style={{ marginTop: 16, textAlign: 'center', color: theme.textMuted, fontSize: 13 }}>
        Already have an account?{' '}
        <button onClick={onLogin} style={{
          background: 'none', border: 'none', color: theme.accent,
          cursor: 'pointer', fontSize: 13, textDecoration: 'underline', padding: 0,
        }}>Sign in</button>
      </p>
    </AuthShell>
  );
}

function friendlyError(code) {
  switch (code) {
    case 'auth/email-already-in-use':   return 'An account with this username already exists.';
    case 'auth/invalid-email':          return 'Invalid username (must be a valid email address).';
    case 'auth/weak-password':          return 'Password must be at least 6 characters.';
    case 'auth/network-request-failed': return 'Network error — check your connection.';
    default:                            return 'Something went wrong. Please try again.';
  }
}
